// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"jut__FieldColumn__fullWidth"};